// Sample demo data — "Keluarga Wijaya" (development/demo only)
export const SAMPLE_DATA = {
  familyName: "Keluarga Wijaya",
  husbandName: "Budi",
  wifeName: "Sinta",
  husbandSalary: 22000000,
  wifeSalary: 14000000,
  sideIncomes: [{ id: "s1", name: "Usaha sampingan", amount: 6000000 }],
  mortgage: 8000000,
  vehicle: 4000000,
  creditCard: 0,
  otherDebt: 1500000,
  livingExpenses: 15000000,
  emergencyFund: 85000000,
};

export const EMPTY_DATA = {
  familyName: "",
  husbandName: "",
  wifeName: "",
  husbandSalary: 0,
  wifeSalary: 0,
  sideIncomes: [],
  mortgage: 0,
  vehicle: 0,
  creditCard: 0,
  otherDebt: 0,
  livingExpenses: 0,
  emergencyFund: 0,
};
